/**
 * SearchButton — botón secundario "Buscar" que, al hacer click, despliega el
 * campo de búsqueda en el mismo lugar (alineado con el diseño, estilo pill).
 * Pensado para ir junto al botón de acción primario de cada módulo.
 *
 *   value, onChange  — estado de la búsqueda (controlado por la página)
 *   placeholder      — texto del input
 *   width            — ancho del input desplegado
 */
import { useEffect, useRef, useState } from 'react'
import { Search, X } from 'lucide-react'
import { Button } from '@/components/ui/Button'

export function SearchButton({ value, onChange, placeholder = 'Buscar…', width = 280 }) {
  const [open, setOpen] = useState(Boolean(value))
  const inputRef = useRef(null)

  useEffect(() => {
    if (open) inputRef.current?.focus()
  }, [open])

  if (!open) {
    return (
      <Button type="button" variant="secondary" onClick={() => setOpen(true)} className="!px-3 sm:!px-6">
        <Search size={18} />
        <span className="hidden sm:inline">Buscar</span>
      </Button>
    )
  }

  return (
    <div
      className="relative"
      style={{ width, maxWidth: '70vw', height: 48, border: '1.5px solid #1E6E3A', borderRadius: 999, background: '#fff' }}
    >
      <Search
        size={18}
        style={{ position: 'absolute', left: 16, top: '50%', transform: 'translateY(-50%)', color: '#1E6E3A' }}
      />
      <input
        ref={inputRef}
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        style={{
          width: '100%',
          height: '100%',
          border: 'none',
          background: 'transparent',
          borderRadius: 999,
          padding: '0 42px 0 42px',
          outline: 'none',
          fontFamily: 'inherit',
          fontSize: 15,
          fontWeight: 500,
          color: '#15321F',
        }}
      />
      <button
        type="button"
        onClick={() => {
          onChange('')
          setOpen(false)
        }}
        title="Cerrar búsqueda"
        style={{
          position: 'absolute',
          right: 12,
          top: '50%',
          transform: 'translateY(-50%)',
          color: '#8B9B8F',
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          display: 'inline-flex',
        }}
      >
        <X size={18} />
      </button>
    </div>
  )
}
